// Handles fragmented UTF-8, CRLF, keep-alive comments and errors in OpenAI-compatible SSE.
export async function* readChatStream(body:ReadableStream<Uint8Array>):AsyncGenerator<string> {
 const reader=body.getReader(),decoder=new TextDecoder();let pending="",done=false;
 function token(line:string):string|undefined {
  if(!line.startsWith("data:"))return;
  const data=line.slice(5).trim();if(!data)return;
  if(data==="[DONE]"){done=true;return;}
  const event=JSON.parse(data);
  if(event.error)throw new Error("模型串流回傳錯誤，請更換模型或再試一次");
  const text=event.choices?.[0]?.delta?.content;
  return typeof text==="string"?text:undefined;
 }
 try {
  while(!done) {
   const part=await reader.read();pending+=decoder.decode(part.value,{stream:!part.done});
   const lines=pending.split(/\r?\n/);pending=lines.pop()??"";
   for(const line of lines){const text=token(line);if(text)yield text;if(done)break;}
   if(part.done){if(pending && !done){const text=token(pending);if(text)yield text;}break;}
  }
 }finally{await reader.cancel().catch(()=>{});reader.releaseLock();}
}
